module.exports = __webpack_public_path__ + "img/3D.aa79903f.png";